import styled from 'styled-components';

import { StatusInfoTypes } from '.';

interface IConContainerProps {
    type: StatusInfoTypes;
}

export const IconContainer = styled.div<IConContainerProps>`
    width: 3.375rem;
    height: 3.375rem;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 1.5rem;
    border: ${({ theme, type }) =>
        `2px solid ${
            type === StatusInfoTypes.SUCCESS
                ? theme.colors.checkbox
                : theme.colors.formError
        }`};
    border-radius: 50%;

    svg {
        width: 2rem;
        height: 2rem;
        fill: ${({ theme, type }) =>
            type === StatusInfoTypes.SUCCESS
                ? theme.colors.checkbox
                : theme.colors.formError};
    }
`;
